import HttpClient, { HTTP_METHODS } from './HttpClient';

import * as encoding from './encoding';
import * as mimeTypes from './mimeTypes';
import MultiPart from './MultiPart';
import readFile from './readFile';

export default HttpClient;
export { HttpClient, HTTP_METHODS, encoding, mimeTypes, MultiPart, readFile };
